export const CELL_TYPES = {
  label: 'label',
  percentage: 'percentage',
  currency: 'currency',
  number: 'NumberInput',
  amount: 'CashInput',
  empty: 'empty',
  null: 'null',
};

export const CELL_TYPES_ARRAY = Object.values(CELL_TYPES);
